import React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { makeStyles } from '@material-ui/core/styles';
import {
    Paper,
    Tabs,
    Tab,
    Container,
} from '@material-ui/core';
import TabPanel from './components/TabPanel'
import FormPerfil from './components/FormPerfil';
import FormFormacaoAcademica from './components/FormFormacaoAcademica';
import FormExperiencia from './components/FormExperiencia';
import FormCursosComplementares from './components/FormCursosComplementares';
import FormDocumentos from './components/FormDocumentos';

import { getProfessionalProfile } from '../../serviceAPI/professionalProfile/getProfessionalProfile';
import { postAddProfessionalProfile } from '../../serviceAPI/professionalProfile/postAddProfessionalProfile';
import { postUpdateProfessionalProfile } from '../../serviceAPI/professionalProfile/postUpdateProfessionalProfile';

import { postAddEducationBackground } from '../../serviceAPI/educationBackground/postAddEducationBackground';
import { postUpdateEducationBackground } from '../../serviceAPI/educationBackground/postUpdateEducationBackground';
import { getDeleteEducationBackground } from '../../serviceAPI/educationBackground/getDeleteEducationBackground';

import { postAddExperience } from '../../serviceAPI/experience/postAddExperience';
import { postUpdateExperience } from '../../serviceAPI/experience/postUpdateExperience';
import { getDeleteExperience } from '../../serviceAPI/experience/getDeleteExperience';

import { postAddExtraCurricularActivity } from '../../serviceAPI/extraCurricularActivity/postAddExtraCurricularActivity';
import { postUpdateExtraCurricularActivity } from '../../serviceAPI/extraCurricularActivity/postUpdateExtraCurricularActivity';
import { getDeleteExtraCurricularActivity } from '../../serviceAPI/extraCurricularActivity/getDeleteExtraCurricularActivity';


const useStyles = makeStyles((theme) => ({
    main: {
        marginBottom: 40
    },
    root: {
        flexGrow: 1,
        width: '100%',
    },
}));

function DadosProfissionais() {
    const classes = useStyles();
    const dispatch = useDispatch();
    const [value, setValue] = React.useState(0);
    const professionalProfile = useSelector(state => state.professionalProfile)

    const handleChange = (event, newValue) => {
        setValue(newValue);
    };

    function a11yProps(index) {
        return {
            id: `scrollable-force-tab-${index}`,
            'aria-controls': `scrollable-force-tabpanel-${index}`,
        };
    }

    async function submitPerfil(title, description, skills) {
        if (professionalProfile.professionalProfileNotFound) {
            await postAddProfessionalProfile(title, skills, description, dispatch);
        } else {
            await postUpdateProfessionalProfile(title, skills, description, dispatch);
        }
        getProfessionalProfile(dispatch);
    }

    async function submitFormacaoAcademica(id, title, formation, college, description, start_date, completion_date) {
        if (id === "") {
            await postAddEducationBackground(title, formation, college, description, start_date, completion_date, dispatch)
        } else {
            await postUpdateEducationBackground(id, title, formation, college, description, start_date, completion_date, dispatch)
        }
        await refreshTab(1);
    }

    async function deleteFormcacaoAcademica(id) {
        await getDeleteEducationBackground(id, dispatch)
        await refreshTab(1);
    }

    async function submitExperiencia(id, title, company, description, start_date, completion_date) {
        if (id === "") {
            await postAddExperience(title, company, description, start_date, completion_date, dispatch)
        } else {
            await postUpdateExperience(id, title, company, description, start_date, completion_date, dispatch)
        }
        await refreshTab(2);
    }

    async function deleteExperiencia(id) {
        await getDeleteExperience(id, dispatch)
        await refreshTab(2);
    }

    async function submitCursos(id, title, college, completion_date) {
        if (id === "") {
            await postAddExtraCurricularActivity(title, college, completion_date, dispatch)
        } else {
            await postUpdateExtraCurricularActivity(id, title, college, completion_date, dispatch)
        }
        await refreshTab(3);
    }

    async function deleteCursos(id) {
        await getDeleteExtraCurricularActivity(id, dispatch)
        await refreshTab(3);
    }

    async function refreshTab(indexTab) {
        setValue(0);
        await getProfessionalProfile(dispatch)
        setValue(indexTab);
    }

    React.useEffect(() => {
        getProfessionalProfile(dispatch)
    }, []);


    return (
        <>
            <Paper className={classes.root}>
                <Tabs
                    value={value}
                    onChange={handleChange}
                    indicatorColor="primary"
                    textColor="primary"
                    scrollButtons="on"
                    variant="scrollable"
                >
                    <Tab label="Perfil" {...a11yProps(0)} />
                    <Tab label="Formação Acadêmica" {...a11yProps(1)} />
                    <Tab label="Experiência" {...a11yProps(2)} />
                    <Tab label="Cursos Complementares" {...a11yProps(3)} />
                    <Tab label="Documentos" {...a11yProps(4)} />
                </Tabs>
            </Paper>
            <TabPanel value={value} index={0}>
                <Container className={classes.main} component="main" maxWidth="sm">
                    <FormPerfil
                        professionalProfile={professionalProfile}
                        onSubmit={submitPerfil}
                    />
                </Container >
            </TabPanel>
            <TabPanel value={value} index={1}>
                <Container className={classes.main} component="main" maxWidth="sm">
                    <FormFormacaoAcademica
                        professionalProfile={professionalProfile}
                        onSubmit={submitFormacaoAcademica}
                        onDelete={deleteFormcacaoAcademica}
                    />
                </Container >
            </TabPanel>
            <TabPanel value={value} index={2}>
                <Container className={classes.main} component="main" maxWidth="sm">
                    <FormExperiencia
                        professionalProfile={professionalProfile}
                        onSubmit={submitExperiencia}
                        onDelete={deleteExperiencia}
                    />
                </Container >
            </TabPanel>
            <TabPanel value={value} index={3}>
                <Container className={classes.main} component="main" maxWidth="sm">
                    <FormCursosComplementares
                        professionalProfile={professionalProfile}
                        onSubmit={submitCursos}
                        onDelete={deleteCursos}
                    />
                </Container >
            </TabPanel>
            <TabPanel value={value} index={4}>
                <Container className={classes.main} component="main" maxWidth="sm">
                    <FormDocumentos />
                </Container >
            </TabPanel>
        </>
    )
}

export default DadosProfissionais;


